import { c as _c } from "react/compiler-runtime";
import { Checkbox, Hint, toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import SettingsLayout from 'modules/profile/components/settings-layout';
import { settingsMenuLocoKeys } from 'modules/profile/constants/settings-menu-loco-keys';
import { updateSalesFunnelSettings } from 'modules/profile/sales-funnels-settings/api/sales-funnels-settings-api';
import SalesFunnelsSettingsSkeleton from 'modules/profile/sales-funnels-settings/components/sales-funnels-settings-skeleton';
import { SalesFunnelsSettingsLoco } from 'modules/profile/sales-funnels-settings/constants/sales-funnels-settings-loco';
import { useSalesFunnelsSettings } from 'modules/profile/sales-funnels-settings/hooks/use-sales-funnels-settings';
import { SalesFunnelsSettingsErrorInterface, SalesFunnelsSettingsInterface } from 'modules/profile/sales-funnels-settings/types/sales-funnels-settings-interface';
import { NextPage } from 'next';
import React, { useEffect, useState } from 'react';
import CodeEditor from 'shared/components/code-editor';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props';
const defaultValues: SalesFunnelsSettingsInterface = {
  trackingCode: null,
  storeUtmData: false
};
const defaultErrors = {
  trackingCode: '',
  storeUtmData: '',
  common: []
};
const SalesFunnelsSettings: NextPage = () => {
  const $ = _c(26);
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [isFetching, setIsFetching] = useState(false);
  const {
    salesFunnelData,
    mutate
  } = useSalesFunnelsSettings();
  let t0;
  if ($[0] !== mutate || $[1] !== t || $[2] !== tempState) {
    t0 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        setIsFetching(true);
        const response = await updateSalesFunnelSettings(tempState);
        await mutate(response.data, false);
        setIsFetching(false);
        toast.success(t("global.changes_saved"));
      } catch (t1) {
        const e = t1;
        setIsFetching(false);
        if (e instanceof BadRequest) {
          const salesFunnelsSettingErrors = e.errors;
          setErrors(prev => ({
            ...prev,
            trackingCode: salesFunnelsSettingErrors.fields.trackingCode?.join("")
          }));
          if (e.errors.common) {
            const commonErrors = e.errors.common;
            setErrors(prev_0 => ({
              ...prev_0,
              common: commonErrors
            }));
          }
        } else {
          toast.error(t("global.error"));
        }
      }
    };
    $[0] = mutate;
    $[1] = t;
    $[2] = tempState;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const onSubmit = t0;
  let t1;
  let t2;
  if ($[4] !== salesFunnelData) {
    t1 = () => {
      if (salesFunnelData) {
        setTempState(salesFunnelData);
      }
    };
    t2 = [salesFunnelData];
    $[4] = salesFunnelData;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  let t3;
  if ($[7] !== tempState) {
    t3 = value => {
      setTempState({
        ...tempState,
        trackingCode: value
      });
    };
    $[7] = tempState;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleChangeTrackingCode = t3;
  const [isCodeValid, setIsCodeValid] = useState(true);
  let t4;
  if ($[9] !== t) {
    t4 = t(settingsMenuLocoKeys.sales_funnel);
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = [{
      caption: t4,
      isStatic: true
    }];
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = !salesFunnelData || !isCodeValid;
  let t7;
  if ($[13] !== errors || $[14] !== handleChangeTrackingCode || $[15] !== isFetching || $[16] !== salesFunnelData || $[17] !== t || $[18] !== tempState) {
    t7 = salesFunnelData ? <div className="bg-background-secondary flex h-fit w-full flex-col gap-7 overflow-x-hidden rounded-md p-5 lg:gap-10 [&>*]:flex-1"><div className="flex flex-col gap-3"><Checkbox label={t("dashboard.settings.sales_funnels_settings.store_UTM")} value={tempState.storeUtmData} disabled={isFetching} onChange={value_0 => setTempState({
          ...tempState,
          storeUtmData: value_0
        })} /><CodeEditor label={<Hint label={t("dashboard.settings.sales_funnels_settings.tracking_code_popover_title")}>{t("dashboard.settings.sales_funnels_settings.tracking_code_title")}</Hint>} value={tempState.trackingCode} onChange={handleChangeTrackingCode} setIsValid={setIsCodeValid} /></div>{errors.common && <>{errors.common.map(_temp)}</>}</div> : <SalesFunnelsSettingsSkeleton />;
    $[13] = errors;
    $[14] = handleChangeTrackingCode;
    $[15] = isFetching;
    $[16] = salesFunnelData;
    $[17] = t;
    $[18] = tempState;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== isFetching || $[21] !== onSubmit || $[22] !== t5 || $[23] !== t6 || $[24] !== t7) {
    t8 = <SettingsLayout titles={t5} onSave={onSubmit} disabled={t6} isFetching={isFetching}>{t7}</SettingsLayout>;
    $[20] = isFetching;
    $[21] = onSubmit;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
};
export const getServerSideProps = getBaseServerSideProps(SalesFunnelsSettingsLoco, 'global.settings');
export default SalesFunnelsSettings;
function _temp(error, index) {
  return <p className="text-danger px-6 text-sm" key={index}>{error}</p>;
}